<div class="app-products">

  <div class="title">
    {{ 'products_hello' | translate }} {{ firstName() }}
  </div>

  <div class="subtitle">
    {{ 'products_subtitle' | translate }}
  </div>

  <button class="coupon-button" (click)="addProduct()">
    {{ 'products_add' | translate | uppercase }}
  </button>

  <div class="separator"></div>

  <div class="cp-table-title">
    @if (registeredSerials().length == 1) {
    {{ registeredSerials().length }} {{ 'products_table_title_s' | translate | uppercase }}
    }
    @else {
    {{ registeredSerials().length }} {{ 'products_table_title_p' | translate | uppercase }}
    }
  </div>

  <div class="cp-table">
    <div class="cp-table-column small cp-table-header">
      <div class="cp-m-left-16">
        {{ 'product' | translate }}
      </div>
    </div>
    <div class="cp-table-column small cp-table-header">
      <div class="cp-m-left-16">
        {{ 'registration_date' | translate }}
      </div>
    </div>
    <div class="cp-table-column small cp-table-header">
      <div class="cp-m-left-16">
        {{ 'extended_warranty' | translate }}
      </div>
    </div>
    <div class="cp-table-column small cp-table-header">
      <div class="cp-m-left-16">
        {{ 'coupon' | translate }}
      </div>
    </div>
    <div class="cp-table-column cp-table-header">
      <div class="cp-m-left-16">
        {{ 'actions' | translate }}
      </div>
    </div>
  </div>

  @for (item of registeredSerials(); track item.id) {
  <div class="cp-table">
    <div class="cp-table-column small table-product">
      <div class="cp-table-row-title">
        <div class="cp-table-row-title-content">
          {{ 'product' | translate }}
        </div>
      </div>
      <div class="trainer-img">
        <img [src]="getTrainerImageURL(item.trainerCode)">
      </div>
      <div class="trainer-data">
        <div class="trainer-name">{{ item.trainerName }}</div>
        <div class="trainer-serial">{{ item.serialCode }}</div>
      </div>
    </div>

    <div class="cp-table-column small table-date">
      <div class="cp-table-row-title">
        <div class="cp-table-row-title-content">
          {{ 'registration_date' | translate }}
        </div>
      </div>
      <div class="cp-m-left-16">{{ item.date | dateFormatted }}</div>
    </div>

    <div class="cp-table-column small table-icon">
      <div class="cp-table-row-title">
        <div class="cp-table-row-title-content">
          {{ 'extended_warranty' | translate }}
        </div>
      </div>
      @if (!checkWarrantyExtensionEnabled(item.trainerCode)) {
      <div class="cp-no-actions cp-m-left-16"></div>
      }
      @else if (!item.warrantyAcceptDate) {
      <img src="/assets/img/ic-not-active.png" class="cp-m-left-16">
      <div class="cp-available">{{ 'warranty_to_activate' | translate }}</div>
      }
      @else if (!item.warrantyAcceptDate) {
      <img src="/assets/img/ic-not-active.png" class="cp-m-left-16">
      <div class="cp-available">{{ 'warranty_not_available' | translate }}</div>
      }
      @else if (!item.expired) {
      <img src="/assets/img/ic-active.png" class="cp-m-left-16">
      <div class="cp-active">{{ 'warranty_active' | translate }}</div>
      }
      @else {
      <img src="/assets/img/ic-not-active.png" class="cp-m-left-16">
      <div class="cp-available">{{ 'warranty_expired' | translate }}</div>
      }
      @if (!item.warrantyAcceptDate && checkWarrantyExtensionEnabled(item.trainerCode)) {
      <button class="cp-table-button cp-mobile" (click)="openWarrantyUpload(item)">
        {{ 'extend_warranty' | translate | uppercase }} <img src="/assets/img/ic-warranty.png">
      </button>
      }
    </div>

    <div class="cp-table-column small table-icon">
      <div class="cp-table-row-title">
        <div class="cp-table-row-title-content">
          {{ 'coupon' | translate }}
        </div>
      </div>
      @if (!item.couponRequestDate) {
      <img src="/assets/img/ic-not-active.png" class="cp-m-left-16">
      <div class="cp-available">{{ 'coupon_available' | translate }}</div>
      }
      @else if (!item.couponAcceptDate) {
      <div class="cp-waiting-icon">
        <img src="/assets/img/ic-waiting.png" class="cp-m-left-16">
        <div class="cp-tooltip">
          {{ 'coupon_tooltip' | translate }}
        </div>
      </div>
      <div class="cp-waiting">{{ 'coupon_waiting' | translate }}</div>
      }
      @else {
      <img src="/assets/img/ic-active.png" class="cp-m-left-16">
      <div class="cp-active">{{ 'coupon_redeemed' | translate }}</div>
      }
      @if (!item.couponRequestDate) {
      <button class="cp-table-button cp-mobile" (click)="couponPressed(item)">
        {{ 'redeem' | translate | uppercase }}
      </button>
      }
    </div>

    <div class="cp-table-column cp-table-actions">
      <div class="cp-table-row-title">
        <div class="cp-table-row-title-content">
          {{ 'actions' | translate }}
        </div>
      </div>
      @if (!item.warrantyAcceptDate && checkWarrantyExtensionEnabled(item.trainerCode)) {
      <button class="cp-table-button cp-m-left-16" (click)="openWarrantyUpload(item)">
        {{ 'extend_warranty' | translate | uppercase }} <img src="/assets/img/ic-warranty.png">
      </button>
      }
      @if (!item.couponRequestDate) {
      <button class="cp-table-button" [class]="{'cp-m-left-16': item.warrantyAcceptDate || !checkWarrantyExtensionEnabled(item.trainerCode)}" (click)="couponPressed(item)">
        {{ 'redeem' | translate | uppercase }}
      </button>
      }
      @if (item.couponRequestDate && item.warrantyAcceptDate) {
      <div class="cp-no-actions cp-m-left-16"></div>
      }
    </div>
  </div>

  <div class="cp-table-separator" [class]="{'cp-m-bottom-60': $last}"></div>
  }
</div>
